// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WwcS","input":"styles_input__3UuM4"};